import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { delay } from 'lodash';
import DatePicker from 'react-datepicker';
import Fa from 'react-fontawesome';
import { Button, Overlay } from 'react-bootstrap';
import DateTimeDisplay from '../date-time-display';
import styles from './styles.css';

function InnerPopover({ children, className, style }) {
  return (
    <div className={`${styles.datePopover} ${className}`} style={style}>
      {children}
    </div>
  );
}
InnerPopover.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
InnerPopover.defaultProps = {
  className: null,
  children: null,
  style: {},
};


class DateCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      show: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.getTarget = this.getTarget.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    delay(() => {
      this.setState({ show: true });
    }, 100);
  }

  handleToggle() {
    this.setState({ show: !this.state.show });
  }

  getValue() {
    return this.state.value;
  }

  getTarget() {
    return ReactDOM.findDOMNode(this.target);
  }

  handleChange(value) {
    this.setState({ value }, () => {
      delay(() => {
        this.props.api.stopEditing();
      }, 100);
    });
  }

  renderInner() {
    const d = this.state.value ? moment(this.state.value) : null;
    const m = d && d.isValid() ? d : null;
    const hasValue = this.props.value !== null && this.props.value !== undefined;
    return (
      <div>
        <DatePicker
          inline
          dateFormat="DD MMM YYYY"
          onChange={this.handleChange}
          showYearDropdown
          scrollableYearDropdown
          isClearable
          selected={m}
          popperPlacement="top-end"
        />
        {hasValue &&
          <div>
            <Button
              onClick={(e) => {
                e.preventDefault();
                this.handleChange(null);
              }}
              block
              bsStyle="link"
            >
              <Fa name="times" /> Clear Date
            </Button>
          </div>
        }
      </div>
    );
  }

  render() {
    const { value } = this.props;
    const { show } = this.state;
    return (
      <div
        style={{ padding: '5px 12px 0' }}
      >
        <span
          ref={(el) => {
            this.target = el;
          }}
          onClick={this.handleToggle}
        >
          <DateTimeDisplay value={value} format="short" />
        </span>
        <Overlay
          show={show}
          onHide={() => this.setState({ show: false })}
          placement="bottom"
          target={this.getTarget}
        >
          <InnerPopover>
            {this.renderInner()}
          </InnerPopover>
        </Overlay>
      </div>
    );
  }
}


DateCell.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment),
  ]),
  api: PropTypes.shape({
    stopEditing: PropTypes.func.isRequired,
  }).isRequired,
};
DateCell.defaultProps = {
  value: null,
};

export default DateCell;
